// export const WEBSITE_URL = "https://bigbasket.com.sg";
//export const WEBSITE_URL = "https://staging.bigbasket.com.sg";

export const WEBSITE_URL = "https://spajelita.com/admin";

export const IMAGE_URL = "https://spajelita.com/admin/assets";
